export default {
  /** Recommended publisher settings */
  connectivityPublisherConfig(state) {
    if (!state.testResultData) return {};

    let connectivityConfig = {};
    if (state.testResultData.video.reason) {
      connectivityConfig.publishVideo = false;
    } else {
      connectivityConfig.frameRate = state.testResultData.video.recommendedFrameRate;
      connectivityConfig.resolution = state.testResultData.video.recommendedResolution;
    }

    if (!state.testResultData.audio.supported) {
      connectivityConfig.publishAudio = false;
    }

    return connectivityConfig;
  },
  /** Recommended subscriber settings */
  connectivitySubscriberConfig(state) {
    if (!state.testResultData) return {};

    return {
      preferredFrameRate: state.testResultData.video.recommendedFrameRate,
      preferredResolution: state.testResultData.video.recommendedResolution
    };
  }
};
